import React from 'react';
import {FormDialog} from 'components/core';
import {FormControlLabel, Checkbox, FormHelperText} from '@material-ui/core';
import {UsersCtx} from 'components/dataProviders/users';

const defaultValues = {name: '', surname1: '', surname2: '', info: '', email: '', profiles: []};

export default function UserDialog({open, onClose=()=>{}, onConfirm=()=>{}, userID=null})
{
    const [loading, setLoading] = React.useState(false);
    const [values, setValues] = React.useState(defaultValues);
    const ctx = React.useContext(UsersCtx);


    React.useEffect(function initializeValues() {
        if(!open){
          setValues(defaultValues);
        }

        if(userID === null) return; // create mode

        if(ctx.data.indexed[userID])
        {
            setValues({...ctx.data.indexed[userID]});
        }
    }, [ctx, userID, open]);

    const handleConfirm = () => {
      setLoading(true);
      let userData = {...values};

      async function apiCallback(data) {
        setLoading(false);
        if(data)
        {
          onConfirm();
          onClose();
        }
      };
      if(userID !== null) ctx.funcs.update(userID, userData).then(apiCallback);
      else ctx.funcs.create(userData).then(apiCallback);
    }

    const handleDialogChange = (newValues) => {
      newValues = {...values, ...newValues};
      setValues(newValues);
    }

    function setUserProfile(profile, value)
    {
        let profilesArr = [...values.profiles]; // important to keep this as a copy or else 
        //the copied object will be a pointer to the original array in the context, modifying it directly

        if(value === false)
        {
            if(profilesArr.includes(profile)) profilesArr.splice(profilesArr.indexOf(profile), 1);
        }
        else
        {
            if(!profilesArr.includes(profile)) profilesArr.push(profile);
        }
        setValues({...values, profiles:profilesArr});
    }
  
    const fields=[
        {
          type: "text",
          label: "Nombre",
          id: "name",
          placeholder: "",
          mandatory: true
        },
        {
          type: "text",
          label: "Apellido 1",
          id: "surname1",
          placeholder: "",
          mandatory: false
        },
        {
          type: "text",
          label: "Apellido 2",
          id: "surname2",
          placeholder: "",
          mandatory: false
        },
        {
          type: "text",
          label: "Email",
          id: "email",
          placeholder: "",
          mandatory: true
        },
        {
          type: "textarea",
          label: "Otra información",
          id: "info",
          placeholder: "",
          mandatory: false
        },
        {
          type: "custom",
          label: "Perfiles",
          id: "profiles",
          content:  function ProfilesSelector(props)
          {
            return <>
            {props.error ? <FormHelperText>{props.error}</FormHelperText> : null}
            <FormControlLabel
            control={<Checkbox color="primary" checked={values.profiles.includes("administrators")} onChange={(ev, checked) => setUserProfile("administrators", checked)} name="administrator" />}
            label="Administrador"
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={values.profiles.includes("experts")} onChange={(ev, checked) => setUserProfile("experts", checked)} name="expert" />}
              label="Experto"
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={values.profiles.includes("operators")} onChange={(ev, checked) => setUserProfile("operators", checked)} name="operator" />}
              label="Operario"
            />
            </>
          }
        }
    ];

    return <FormDialog
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      onChange={handleDialogChange}
      loading={loading}
      title={userID === null ? "Nuevo Usuario" : "Editar Usuario"}
      subtitle={userID === null ? "Rellena la ficha de usuario y selecciona su perfil" : "Modifica los datos del usuario"}
      confirm={userID === null ? "Crear Usuario" : "Guardar"}
      cancel="Cancelar"
      fields={fields}
      values={values}
      fieldErrors={values.profiles.length <= 0 ? {"profiles": "Todos los usuarios deben tener al menos un perfil"} : undefined}
      />
}
